import restaurants from './restaurant';
import products from './product';
import basket from './basket';
import user from './user';
import language from './language';
import order from './order';
import payment from './payment';
import pickUpTime from './pickUpTime';

export {
  restaurants,
  products,
  basket,
  user,
  language,
  order,
  payment,
  pickUpTime
};


// WEBPACK FOOTER //
// ./src/reducers/index.js